import { notify } from "@utils/notify"
import axiosPrivateMl from "./axiosPrivateMl"

// Fetch adsets by campaign
const fetchFreshFacebookAdsetsByCampaign = async (payload) => {
  const response = await axiosPrivateMl.post(
    "/fetch_fresh_facebook_adsets_by_campaign",
    payload
  )
  if (response.data?.error) {
    console.error("Error fetching adsets by campaign:", response.data.error)
    notify("FB rate limit exceeded, showing cached ad sets", "warning");
  }
  return response.data
}

// fetch campaign
const fetchFreshFacebookCampaigns = async (payload) => {
  const response = await axiosPrivateMl.post(
    "/fetch_fresh_facebook_campaigns",
    payload
  )
  return response.data
}

export { fetchFreshFacebookCampaigns, fetchFreshFacebookAdsetsByCampaign }
